export interface CreativeRun {
  runId: string;
  creativeId: string;
  networkId: number;
  completedAt: string | null;
  selected: Record<string, string>;
}

export interface RunChange {
  label: string;
  from: string;
  to: string;
}

function titleCase(words: string): string {
  return words.replace(/(^|\s)\S/g, (letter) => letter.toUpperCase());
}

function fieldLabel(key: string): string {
  return titleCase(key.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase());
}

function fieldValue(value: string | undefined): string {
  const entered = (value ?? '').trim();
  if (entered === '') return '—';
  return entered === entered.toLowerCase() && !entered.includes('_')
    ? entered
    : titleCase(entered.toLowerCase().replace(/_/g, ' '));
}

export function runsFor(
  runs: CreativeRun[],
  creativeId: string,
  networkId: number | null,
): CreativeRun[] {
  const mine = runs.filter((run) => run.creativeId === creativeId);
  if (networkId !== null) return mine.filter((run) => run.networkId === networkId);
  const seen = new Set<string>();
  return mine.filter((run) => !seen.has(run.runId) && seen.add(run.runId) !== undefined);
}

export function runChanges(
  current: Record<string, string>,
  previous: Record<string, string> | undefined,
): RunChange[] {
  if (previous === undefined) return [];
  const keys = [...new Set([...Object.keys(previous), ...Object.keys(current)])];
  return keys
    .filter((key) => (previous[key] ?? '') !== (current[key] ?? ''))
    .map((key) => ({
      label: fieldLabel(key),
      from: fieldValue(previous[key]),
      to: fieldValue(current[key]),
    }));
}

export function runChangeSummary(changes: RunChange[]): string {
  const [only] = changes;
  if (only === undefined) return '';
  return changes.length === 1 ? `${only.label} changed` : `${changes.length} changes`;
}
